export const FLUSH_PROGRAM: 'PROGRAM/FLUSH' = 'PROGRAM/FLUSH';
export const REQUEST_ACTIVE: 'PROGRAM/REQUEST_ACTIVE' = 'PROGRAM/REQUEST_ACTIVE';
export const REQUEST_ACTIVE_LOADING: 'PROGRAM/REQUEST_ACTIVE_LOADING' = 'PROGRAM/REQUEST_ACTIVE_LOADING';
export const REQUEST_ACTIVE_SUCCESS: 'PROGRAM/REQUEST_ACTIVE_SUCCESS' = 'PROGRAM/REQUEST_ACTIVE_SUCCESS';
export const REQUEST_ACTIVE_FAILURE: 'PROGRAM/REQUEST_ACTIVE_FAILURE' = 'PROGRAM/REQUEST_ACTIVE_FAILURE';
export const REQUEST_FINISH_MANUALLY: 'PROGRAM/REQUEST_FINISH_MANUALLY' = 'PROGRAM/REQUEST_FINISH_MANUALLY';
export const REQUEST_FINISH_MANUALLY_LOADING: 'PROGRAM/REQUEST_FINISH_MANUALLY_LOADING' =
	'PROGRAM/REQUEST_FINISH_MANUALLY_LOADING';
export const REQUEST_FINISH_MANUALLY_SUCCESS: 'PROGRAM/REQUEST_FINISH_MANUALLY_SUCCESS' =
	'PROGRAM/REQUEST_FINISH_MANUALLY_SUCCESS';
export const REQUEST_FINISH_MANUALLY_FAILURE: 'PROGRAM/REQUEST_FINISH_MANUALLY_FAILURE' =
	'PROGRAM/REQUEST_FINISH_MANUALLY_FAILURE';
export const REQUEST_FINISH_BUTTON: 'PROGRAM/REQUEST_FINISH_BUTTON' = 'PROGRAM/REQUEST_FINISH_BUTTON';
export const REQUEST_FINISH_BUTTON_SUCCESS: 'PROGRAM/REQUEST_FINISH_BUTTON_SUCCESS' =
	'PROGRAM/REQUEST_FINISH_BUTTON_SUCCESS';
export const REQUEST_FINISH_BUTTON_FAILURE: 'PROGRAM/REQUEST_FINISH_BUTTON_FAILURE' =
	'PROGRAM/REQUEST_FINISH_BUTTON_FAILURE';
